module.exports = __webpack_public_path__ + "static/img/logo59.2f11e90.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo59.png
// module id = 4FCE
// module chunks = 1